import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import ThirdServerAPI from '../../api/thirdServer';
import { throwErrorMessage } from '../utils/api';
import { IDBObjectStore } from 'fake-indexeddb';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isUpdating: false,
    isCheckoutInProcess: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },

  getPromptList: ($state) => {
    return $state.records;
  },
  // 改为普通函数
  getPromptDetail($state) {
    return (promptId) => {
      const prompt = $state.records.find(record => record.id === promptId);
      return prompt;
    };
  }
};

export const actions = {
  // 创建prompt
  createMerchantPrompt: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.createMerchantPrompt(data);
      if (response?.data?.data?.item) {
        commit(types.default.ADD_PROMPT, response?.data?.data?.item);
      }
      return response?.data
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },

  // prompt列表
  scanMerchantPrompts: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.scanMerchantPrompts(data);
      if (response?.data?.data?.items) {
        commit(types.default.SET_PROMPTS, response?.data?.data?.items);
      }
      if (response?.data?.code != 200) {
        useAlert(response?.data?.message);
        return
      }
      return response?.data
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },

  // 删除prompt
  deleteMerchantPrompt: async ({ commit }, id) => {
    try {
      const response = await ThirdServerAPI.deleteMerchantPrompt({id});
      if (response?.data?.code == 200) {
        commit(types.default.DELETE_PROMPT, id);
      } else {
        useAlert(response?.data?.message);
        return
      }
      return response?.data
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },

  // 修改prompt的状态
  updateMerchantPromptStatus: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.updateMerchantPromptStatus(data);
      if (response?.data?.data?.item) {
        commit(types.default.UPDATE_PROMPT, response?.data?.data?.item);
      } else {
        useAlert(response?.data?.message);
        return
      }
      return response?.data
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },

  // 修改prompt
  updateMerchantPromptData: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.updateMerchantPromptData(data);
      if (response?.data?.data?.item) {
        commit(types.default.UPDATE_PROMPT, response?.data?.data?.item);
      } else {
        useAlert(response?.data?.message);
        return
      }
      return response?.data
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  }
};

export const mutations = {
  [types.default.SET_PROMPTS]: MutationHelpers.set,
  [types.default.ADD_PROMPT]: MutationHelpers.create,
  [types.default.UPDATE_PROMPT]: MutationHelpers.update,
  [types.default.DELETE_PROMPT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
